import React from 'react'
import App from '../../../components/app/App'
import LogoutContainer from './LogoutContainer'

export default () => (
    <App>
        <LogoutContainer />
    </App>
)
